import React from 'react';
import './NoSpinAlert.css';
import CloseIcon from '@mui/icons-material/Close';

const NoSpinAlert = ({ onClose, colors = {} }) => {
  const getColorValue = (color) => {
    // RGB değerini dönüştür
    if (color && color.includes('rgba')) {
      return color;
    }
    return color || '#1A2234';
  };

  return (
    <div 
      className="no-spin-overlay"
      style={{
        background: colors.noSpinOverlayBg || "rgba(15, 23, 42, 0.95)"
      }}
    >
      <div 
        className="no-spin-modal"
        style={{
          background: `linear-gradient(165deg, ${colors.noSpinModalGradient1 || '#1A2234'}, ${colors.noSpinModalGradient2 || '#2E4057'})`,
          borderColor: colors.noSpinModalBorder || "rgba(255, 255, 255, 0.1)"
        }}
      >
        <button className="close-button" onClick={onClose}>
          <CloseIcon />
        </button>
        
        <div className="no-spin-content">
          <div className="icon-wrapper">
            <span className="alert-icon">🎰</span>
          </div>
          
          <h2 style={{ color: colors.noSpinModalTitle || "#FFFFFF" }}>Spin Hakkı Bulunamadı</h2>
          <p style={{ color: colors.noSpinModalText || "rgba(255, 255, 255, 0.8)" }}>Üzgünüz, şu anda aktif bir spin hakkınız bulunmuyor.</p>
          
         
        </div>
      </div>
    </div>
  );
};

export default NoSpinAlert; 